export interface ProgressBarOptions {
  current: number;
  total: number;
}

export class ProgressBar {
  private container: HTMLElement;
  private fillElement: HTMLElement;
  private textElement: HTMLElement;

  constructor(parentElement: HTMLElement, options: ProgressBarOptions) {
    this.container = document.createElement('div');
    this.container.className = 'progress-container';

    const bar = document.createElement('div');
    bar.className = 'progress-bar';

    this.fillElement = document.createElement('div');
    this.fillElement.className = 'progress-fill';

    this.textElement = document.createElement('div');
    this.textElement.className = 'progress-text';

    bar.appendChild(this.fillElement);
    this.container.appendChild(bar);
    this.container.appendChild(this.textElement);

    parentElement.appendChild(this.container);

    this.update(options);
  }

  update(options: ProgressBarOptions): void {
    const percentage = options.total > 0
      ? Math.round((options.current / options.total) * 100)
      : 0;

    this.fillElement.style.width = `${percentage}%`;
    this.textElement.textContent = `Pergunta ${options.current} de ${options.total}`;
  }

  complete(): void {
    this.fillElement.style.width = '100%';
    this.textElement.textContent = 'Diagnóstico concluído!';
  }

  getElement(): HTMLElement {
    return this.container;
  }

  remove(): void {
    this.container.remove();
  }
}
